// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__czZzM","row":"styles_row__3AH_9"};